import { render, staticRenderFns } from "./ModalIconButton.vue?vue&type=template&id=5bfc6cde&scoped=true&"
import script from "./ModalIconButton.vue?vue&type=script&lang=js&"
export * from "./ModalIconButton.vue?vue&type=script&lang=js&"
import style0 from "./ModalIconButton.vue?vue&type=style&index=0&id=5bfc6cde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfc6cde",
  null
  
)

/* custom blocks */
import block0 from "./ModalIconButton.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bfc6cde')) {
      api.createRecord('5bfc6cde', component.options)
    } else {
      api.reload('5bfc6cde', component.options)
    }
    module.hot.accept("./ModalIconButton.vue?vue&type=template&id=5bfc6cde&scoped=true&", function () {
      api.rerender('5bfc6cde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/ModalIconButton.vue"
export default component.exports